<script setup lang="ts">
  import { ref } from "vue"
  import { Dialog, DialogContent } from "@/components/ui/dialog"

  import SwitchCancellationContent from "./SwitchCancellationContent.vue"
  import SwitchCancelledContent from "./SwitchCancelledContent.vue"

  const switchCancellationSuccess = ref(false)

  const emit = defineEmits<{ switchCancelled: [] }>()
</script>

<template>
  <Dialog>
    <slot />
    <DialogContent class="flex flex-col gap-6">
      <SwitchCancellationContent
        v-if="!switchCancellationSuccess"
        v-model:success="switchCancellationSuccess"
      />
      <SwitchCancelledContent
        v-else
        @switch-cancelled="emit('switchCancelled')"
      />
    </DialogContent>
  </Dialog>
</template>
